import { render, staticRenderFns } from "./WGFloatingButton.vue?vue&type=template&id=3ffc027e&scoped=true&"
import script from "./WGFloatingButton.vue?vue&type=script&lang=js&"
export * from "./WGFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./WGFloatingButton.vue?vue&type=style&index=0&id=3ffc027e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc027e",
  null
  
)

export default component.exports